module.exports = __webpack_public_path__ + "img/7ed9622.png";